import '../../../core/styles/virtualFocus.css';
import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/diagnostic-tooltip.css';
import '../FilterField.css';
import '../suggestions/SuggestionsOverlay.css';
import '../suggestions/Suggestion.css';
import './FilterStatement.css';
export var escapeCharacter = '_ia7amm5-3-12-1';
export var highlight = '_ia7amm6-3-12-1';
export var highlighting = {syntax:'_ia7amm0-3-12-1',minimal:'_ia7amm1-3-12-1'};
export var incompleteStatement = '_ia7amm4-3-12-1';
export var root = '_ia7amm2-3-12-1 _96tj13c-3-12-1';
export var statement = '_ia7amm3-3-12-1';
export var whitespace = '_ia7amm7-3-12-1';